import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import {Control, Errors, LocalForm} from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import {Link} from "react-router-dom";
import Warning from "./pop";
import ModalExample from "./jdbcpopup";
import 'jspdf-autotable'
import { Container, Row, Col } from 'reactstrap';
import Checkbox from "../../elements/Checkbox";
import {config} from "../../../utility/swaggerClient";
import FilesTable from "../CreateDataFactoryProject/table";
import Spinner from "../Snowflake/as/Spinner";
// import './style.css'

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.datapipeline',
    description: 'Page Header Title',
    defaultMessage: 'User Management'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ''
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const devenv = "development-test";

class BuildCode extends Component {
  componentDidMount(){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    let prj =  this.props.location.state[0].project;
    let datafacotry = this.props.location.state[0].dataFactory;
    let customerid = this.props.location.state[0].customer;
    let dataFactoryId = this.state.dataFactoryId;
    fetch(`${config.protocol}://${config.host}/api/project/envlist/` + customerid + '/' + datafacotry + '/' + prj + '/' + dataFactoryId, requestOptions).then((response)=>{
      return response.json();
    }).then((res)=>{
      if(res.code === 200){
        let copyEnvList = [];
        let envList = [];
        let rawenv = res.data;
        let copydevenv = {};
        rawenv.sort((a,b)=>{
          return a.environment.id - b.environment.id;
        })

        rawenv.forEach((item)=>{
          if(item.environment.envName === devenv){
            copydevenv = item.environment;
          }
          envList.push(item.environment);
          if(item.envJson !== null){
            copyEnvList.push(item.environment);
          }
        })

        if(copyEnvList.length === 0){
          envList = [copydevenv];
        }
        this.setState({copyEnvList : copyEnvList, afterload : true, rawenv : rawenv , envList : envList});
      }
    })
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      afterload: false,
      env: "",
      envid: "",
      copyenvid: "",
      envjson: "",
      targetenvjson: "",
      batchConfig: "",
      copyenv: "",
      graphraw: "",
      dataFactory: this.props.location.state[0].dataFactory,
      companyname: this.props.location.state[0].companyname,
      customer  : this.props.location.state[0].customer,
      dataFactoryId  : this.props.location.state[0].dataFactoryId,
      tag  : this.props.location.state[0].tag,
      project  : this.props.location.state[0].project,
      title: "BUILD & RELEASE SOURCE CODE",
      subtitle: "Create a target environment",
      page: 1,
      partitionnum: 200,
      schema_validation: false,
      debug: false,
      copyEnvList: [],
      envList: [],
      rawenv: [],
      jdbcobj: {},
      jdbclist: {},
      jdbcrow: "",
      jdbcrowIdx: "",
      releasebtn: false,
      confirmationText: "",
      batchhost: "",
      batchusername: "",
      batchpassword: "",
      loading: false
    };
  }

  openModal = ()=>{};
  openModal2 = ()=>{};

  getenvjson = ()=>{
    this.setState({loading: true});
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
      };
      let prj =  this.props.location.state[0].project;
      let datafacotry = this.props.location.state[0].dataFactory;
      let customerid = this.props.location.state[0].customer;
      let dataFactoryId = this.state.dataFactoryId;
      let envname = "";
      fetch(`${config.protocol}://${config.host}/api/project/defaultenvjson/`+ customerid + '/' + datafacotry + '/' + prj + '/' + dataFactoryId, requestOptions).then((response)=>{
        return response.json();
      }).then((data)=>{
        if(data.code === 200){
          let j = JSON.parse(data.data);
          console.log(j);

          if(this.state.env.envName === devenv && this.state.copyEnvList.length ===0){
            envname = devenv;
            this.setState({
              batchConfig: j.batch,
              envjson : j.env,
              targetenvjson : JSON.parse(data.data).env,
              debug : j.env.env.debug,
              schema_validation : j.env.env.schema_validation,
              partitionnum : j.env.spark_conf["spark.sql.shuffle.partitions"],
              page:2,
              subtitle: "Update database name mappings for target environment",
              jdbcobj: JSON.parse(j.jdbc)
            })
          }
          else{
            if(this.state.env.envName === devenv){
              envname = devenv;
              this.copyenvconfig(this.state.env);
            }else{
              envname = this.state.copyenv.envName;
              this.copyenvconfig(this.state.copyenv);
            }
            let envjson = this.state.envjson;
            this.setState({
              batchConfig: j.batch,
              debug : envjson.env.debug,
              schema_validation : envjson.env.schema_validation,
              partitionnum : envjson.spark_conf["spark.sql.shuffle.partitions"],
              page:2,
              subtitle: "Update database name mappings for target environment",
              jdbcobj: JSON.parse(j.jdbc)
            })
            console.log(this.state.envjson)
          }

          let modal = {
            host:"",
            name:"",
            port:"",
            dbname:"",
            dbpassword:"",
            dbusername:"",
            driver:"",
            version:"",
            hostport:""
          }
          let jdbclist = [];
          this.state.jdbcobj.jdbcDataSources.forEach((item)=>{
              let jdbc = {...modal};
            this.state.jdbcobj.env.forEach((jdbcenv)=>{
              if(jdbcenv.name === envname){
                jdbcenv.jdbcDataSources.forEach((src)=>{
                  if(item.name === src.name){
                    jdbc.host = src.host;
                    jdbc.name = src.name;
                    jdbc.port = src.port;
                    jdbc.dbname = src.dbname;
                    jdbc.dbpassword = src.dbpassword;
                    jdbc.dbusername = src.dbusername;
                    jdbc.driver = item.driver;
                    jdbc.version = item.version;
                    jdbc.hostport = src.host + ":" + src.port;
                  }
                })
                jdbclist.push(jdbc);
              }
            })
          })
          this.setState({jdbclist : jdbclist});
          console.log(jdbclist)

          let root = this.state.batchConfig.split("[sql]");
          let hostlevel = root[0].split('host=')[1];
          let arr = hostlevel.split('user_name=');
          let host = arr[0];
          arr = arr[1].split('pass_word=');
          let username = arr[0];
          let password = arr[1].trim();


          this.setState({loading: false,batchhost : host.trim(), batchusername: username.trim(), batchpassword : password.trim()})



        }
      })
  }

  copyenvconfig=(v)=>{
    this.state.rawenv.forEach((item)=>{
      if(item.environment.envName === v.envName){
        this.setState({envjson: JSON.parse(item.envJson), targetenvjson : JSON.parse(item.envJson)})
      }
    })
  }

  updateEnvJson = ()=>{
    this.setState({loading: true});
    //env.json
    let t= {...this.state.envjson};
    t.env.debug=this.state.debug;
    t.env.schema_validation=this.state.schema_validation;
    t.spark_conf["spark.sql.shuffle.partitions"]=this.state.partitionnum;
    this.setState({envjson:t});
    //batchconfig
    let batch = "[mysql]\r\nhost=" + this.state.batchhost +"\r\nuser_name=" + this.state.batchusername + "\r\npass_word=" + this.state.batchpassword + "\r\n[sql]\r" + this.state.batchConfig.split("[sql]")[1];
    console.log(batch)
    //jdbc metadata
    let jdbcobj = this.state.jdbcobj;
    let hasEnvname = false;
    jdbcobj.env.forEach((jdbcenv,index)=>{
      if(jdbcenv.name === this.state.env.envName){
        hasEnvname = true;
        jdbcobj.env[index] = {
          "name": this.state.env.envName,
          "jdbcDataSources": []
        };

        this.state.jdbclist.forEach((jdbcsrc)=>{
          let modal = {
            host:jdbcsrc.host,
            name:jdbcsrc.name,
            port:jdbcsrc.port,
            dbname:jdbcsrc.dbname,
            dbpassword:jdbcsrc.dbpassword,
            dbusername:jdbcsrc.dbusername,
          }
          jdbcobj.env[index].jdbcDataSources.push(modal);
        })
      }
    })
    if(!hasEnvname){
      let env = {
        "name": this.state.env.envName,
        "jdbcDataSources": []
      };
      this.state.jdbclist.forEach((jdbcsrc)=>{
        let modal = {
          host:jdbcsrc.host,
          name:jdbcsrc.name,
          port:jdbcsrc.port,
          dbname:jdbcsrc.dbname,
          dbpassword:jdbcsrc.dbpassword,
          dbusername:jdbcsrc.dbusername,
        }
        env.jdbcDataSources.push(modal);
      })
      jdbcobj.env.push(env);
    }

    console.log(jdbcobj)

    //submit
    let body = JSON.stringify({
                                      envjson : JSON.stringify(this.state.envjson),
                                      batch: batch,
                                      jdbc: JSON.stringify(jdbcobj)
                                    });
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
      body
    };
    let prj =  this.props.location.state[0].project;
    let datafacotry = this.props.location.state[0].dataFactory;
    let customerid = this.props.location.state[0].customer;
    let dataFactoryId = this.state.dataFactoryId;
    let envid = this.state.env.id;
    fetch(`${config.protocol}://${config.host}/api/project/envjson/`+ customerid + '/' + datafacotry + '/' + prj + '/'+ envid +'/'+dataFactoryId , requestOptions).then((response)=>{
      return response.json();
    }).then((response)=>{
      if(response.code === 200){
        this.setState({loading: false,page:5, subtitle: "Release source code to customer"})
      }
    })
  }

  selectItem = (value,i)=>{
    //alert(i);
    console.log(i);
    console.log(value);
    this.setState({jdbcrow: value,jdbcrowIdx: i});
  };

  changejdbsrow=(v)=>{
    this.setState({jdbcrow : v})
  }

  editjdbc = ()=>{
    //update jdbcrow to jdbc obj
    let temp = this.state.jdbclist;
    temp[this.state.jdbcrowIdx] = this.state.jdbcrow;
    this.setState({jdbclist:temp });
    console.log(this.state.jdbclist)
  }

  setEnv = (v)=>{
    const temp = this.state.envList[v];
    this.setState({env : temp,envid : v});
    console.log(temp)
  }

  setCopyenv = (v)=>{
    const temp = this.state.copyEnvList[v];
    this.setState({copyenv: temp, copyenvid: v})
  }

  checkRelease = (e)=>{
    let releasebtn = this.state.releasebtn;
    this.setState({releasebtn : !releasebtn});
  }

  release = ()=>{
    this.setState({loading: true});
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    let prj =  this.props.location.state[0].project;
    let datafacotry = this.props.location.state[0].dataFactory;
    let customerid = this.props.location.state[0].customer;
    let dataFactoryId = this.state.dataFactoryId;
    let envname = this.state.env.envName;
    let tag = this.state.tag;
    let releasebtn = this.state.releasebtn ? 1 : 0;
    fetch(`${config.protocol}://${config.host}/api/project/releasecode/`+ customerid + '/' + datafacotry + '/' + prj + '/' + envname + '/' + dataFactoryId + '/' + tag + '/' + releasebtn, requestOptions).then((response)=>{
      return response.json();
    }).then((res)=>{
            console.log(this.state)
            console.log("66666")
            this.setState({loading: false});
            if(res.code === 200){
              this.setState({page:6, subtitle: "Build source code - success"})
            }else{
              console.log(this.state)
              let confirmationText = "STM version " + tag + " release failed.";

              this.setState({confirmationText : confirmationText});
              this.openModal2();
            }
        })
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
          </title>
        </Helmet>
        <Header
          title={this.state.title}
          subtitle={this.state.subtitle}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />
        {this.state.loading && (
          <div className="spinnerbox">
            <Spinner />
          </div>
        )}
        <Warning
          hasTitle
          warning
          className="modal_sm"
          reset={()=>{}}
          setClick={click => this.openModal2 = click}
          content={this.state.confirmationText}
        />

        <ModalExample
          className="modal_md"
          reset={()=> {this.editjdbc()}}
          setClick={click => this.openModal = click}
          jdbcrow = {this.state.jdbcrow}
          changejdbsrow = {this.changejdbsrow}
        />


        <div className="main">
          {this.state.afterload &&(
            <div
              className="panel"
              style={{
                width: '90%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {this.state.page === 1 &&(
                <LocalForm
                  model = "company"
                  className="form"
                  onSubmit={()=>{this.getenvjson();}}
                >
                  <div>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>

                      <Control.text model="company.dataFactory"
                                    value = {this.state.dataFactory}
                                    type="string"
                                    readOnly
                                    />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Pipeline Project Name
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.project}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Target Environment Name
                      </label>

                      <Control.select
                        model=".env"
                        autoFocus
                        value={this.state.envid}
                        onChange={(e) => (this.setEnv(e.target.value))}
                        required
                      >
                        {(this.state.env === "" || this.state.env === null) && <option value="">Select a target environment</option>}
                        {this.state.envList.map((item,i) => <option key={item.id} value={i}>{item.envName.toUpperCase()}</option>)}
                      </Control.select>
                    </fieldset>

                    {this.state.env !== "" && this.state.env.envName !== devenv && this.state.copyEnvList.length !==0 &&(
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          Copy Environment Configuration from
                        </label>

                        <Control.select
                          model=".copyenv"
                          autoFocus
                          value={this.state.copyenvid}
                          onChange={(e) => (this.setCopyenv(e.target.value))}
                          required
                        >
                          {(this.state.copyenv === "" || this.state.copyenv === null) && <option value="">Select a target environment to copy environment configuration from
                          </option>}
                          {this.state.copyEnvList.map((item,i) => <option key={item.id} value={i}>{item.envName.toUpperCase()}</option>)}
                        </Control.select>
                      </fieldset>
                    )}


                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <Link to={{
                        pathname: '/en-CA/projectmanagement/' + this.props.location.state[0].dataFactory + '/' + this.props.location.state[0].dataFactoryId,
                        state:[{
                          dataFactory : this.state.dataFactory,
                          dataFactoryId : this.state.dataFactoryId,
                          companyname : this.state.companyname,
                          customer : this.state.customer,
                          project: this.state.project
                        }]
                      }}>
                        <button
                          className="button"
                          style={{ marginRight: '40px' }}
                        >
                          <FormattedMessage
                            id="run-assessment.back.button.name"
                            textTransform="capitalize"
                            defaultMessage="Back"
                          />
                        </button>
                      </Link>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                        type="submit"
                      >
                        NEXT
                      </button>
                    </div>
                  </div>
                </LocalForm>
              )}

              {this.state.page === 2 &&(
                <LocalForm
                  model = "company"
                  className="form"
                  onSubmit={()=>{
                      this.state.jdbclist.length === 0 ?
                        this.setState({page:4, subtitle: "Update target environment  JDBC data source connectivity"}) :
                        this.setState({page:3, subtitle: "Update target environment  JDBC data source connectivity"})
                  }}
                >
                  <div>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>

                      <Control.text model="company.dataFactory"
                                    value = {this.state.dataFactory}
                                    type="string"
                                    readOnly
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Pipeline Project Name
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.project}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Target Environment
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.env.envName.toUpperCase()}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <label style={{ textTransform: 'capitalize' }}>
                      Update Hive Database Name Mappings:
                    </label>
                    <Container>
                      <Row>
                        <Col xs="6">
                            <label style={{ textTransform: 'capitalize' }}>
                              Hive Database Name in Default Environment
                            </label>
                        </Col>
                        <Col xs="6">
                            <label style={{ textTransform: 'capitalize' }}>
                              Hive Database Name in Target Environment
                            </label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.envjson.env.hive.eim_encrypted}
                                          type="string"
                                          readOnly/>
                          </fieldset>
                        </Col>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.targetenvjson.env.hive.eim_encrypted}
                                          onChange={(e)=>{let temp = {...this.state.targetenvjson}; temp.env.hive.eim_encrypted = e.target.value; this.setState({targetenvjson : temp})}}
                                          type="string"
                            />
                          </fieldset>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.envjson.env.hive.eim_unencrypted}
                                          type="string"
                                          readOnly/>
                          </fieldset>
                        </Col>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.targetenvjson.env.hive.eim_unencrypted}
                                          onChange={(e)=>{let temp = {...this.state.targetenvjson}; temp.env.hive.eim_unencrypted = e.target.value; this.setState({targetenvjson : temp})}}
                                          type="string"
                            />
                          </fieldset>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.envjson.env.hive.bw_customer_analytics_preprod}
                                          type="string"
                                          readOnly/>
                          </fieldset>
                        </Col>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.targetenvjson.env.hive.bw_customer_analytics_preprod}
                                          onChange={(e)=>{let temp = {...this.state.targetenvjson}; temp.env.hive.bw_customer_analytics_preprod = e.target.value; this.setState({targetenvjson : temp})}}
                                          type="string"
                                          />
                          </fieldset>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.envjson.env.hive.businessvault_unencrypted}
                                          type="string"
                                          readOnly/>
                          </fieldset>
                        </Col>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.targetenvjson.env.hive.businessvault_unencrypted}
                                          onChange={(e)=>{let temp = {...this.state.targetenvjson}; temp.env.hive.businessvault_unencrypted = e.target.value; this.setState({targetenvjson : temp})}}
                                          type="string"
                                          />
                          </fieldset>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.targetenvjson.env.hive.costar_encrypted_raw}
                                          type="string"
                                          readOnly/>
                          </fieldset>
                        </Col>
                        <Col xs="6">
                          <fieldset>
                            <Control.text model="company.project"
                                          value = {this.state.targetenvjson.env.hive.costar_encrypted_raw}
                                          onChange={(e)=>{let temp = {...this.state.targetenvjson}; temp.env.hive.costar_encrypted_raw = e.target.value; this.setState({targetenvjson : temp})}}
                                          type="string"
                                          />
                          </fieldset>
                        </Col>
                      </Row>
                    </Container>

                    {this.state.envjson.env.hasOwnProperty("jdbc") && (
                      <div>
                        <label style={{ textTransform: 'capitalize' }}>
                          Update Schema Name for JDBC Data Sources:
                        </label>
                        <Container>
                          {Object.keys(this.state.envjson.env.jdbc).map((k,i) => (
                            <Row  key={i}>
                              <Col xs="6">
                                <fieldset>
                                  <label style={{ textTransform: 'capitalize' }}>
                                    {k}
                                  </label>

                                  <Control.text model="company.project"
                                                value = {this.state.envjson[k]}
                                                type="string"
                                                readOnly/>
                                </fieldset>
                              </Col>

                              <Col xs="6">
                                <fieldset>
                                  <label style={{ textTransform: 'capitalize' }}>
                                    {k}
                                  </label>

                                  <Control.text model="company.project"
                                                value = {this.state.targetenvjson.env.jdbc[k]}
                                                onChange={(e)=>{let temp = {...this.state.targetenvjson}; temp.env.jdbc[k] = e.target.value; this.setState({targetenvjson : temp})}}
                                                type="string"
                                  />
                                </fieldset>
                              </Col>
                            </Row>
                          ))}
                        </Container>
                      </div>
                    )}

                    <div className="button-container" style={{ textAlign: 'center' }}>
                        <button
                          className="button"
                          style={{ marginRight: '40px' }}
                          onClick={()=>{console.log(this.state.env);this.setState({page:1,subtitle: "Create a target environment"})}}
                        >
                          <FormattedMessage
                            id="run-assessment.back.button.name"
                            textTransform="capitalize"
                            defaultMessage="Back"
                          />
                        </button>
                        <button
                          className="button"
                          style={{ marginRight: '40px' }}

                        >
                          NEXT
                        </button>
                    </div>
                  </div>
                </LocalForm>
              )}

              {this.state.page === 3 &&(
                <LocalForm
                  model = "company"
                  className="form"
                  onSubmit={()=>{this.setState({page:4,subtitle: "Update Other Environment Settings"})}}
                >
                  <div>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>

                      <Control.text model="company.dataFactory"
                                    value = {this.state.dataFactory}
                                    type="string"
                                    readOnly
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Pipeline Project Name
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.project}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Target Environment
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.env.envName.toUpperCase()}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <label style={{ textTransform: 'capitalize' }}>
                      JDBC Data Sources
                    </label>
                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={()=>this.openModal()}
                      disabled={this.state.jdbcrow === ""}
                    >
                      Edit
                    </button>

                    <UserTable style={{}} data={this.state.jdbclist} selectItem={this.selectItem}  username={this.props.username}/>

                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                        onClick={()=>{this.setState({page:2,subtitle: "Create a target environment"})}}
                      >
                        <FormattedMessage
                          id="run-assessment.back.button.name"
                          textTransform="capitalize"
                          defaultMessage="Back"
                        />
                      </button>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                      >
                        NEXT
                      </button>
                    </div>
                  </div>
                </LocalForm>
              )}

              {this.state.page === 4 &&(
                <LocalForm
                  model = "company"
                  className="form"
                  onSubmit={()=>{this.updateEnvJson()}}
                >
                  <div>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>

                      <Control.text model="company.dataFactory"
                                    value = {this.state.dataFactory}
                                    type="string"
                                    readOnly
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Pipeline Project Name
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.project}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Target Environment
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.env.envName.toUpperCase()}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <label style={{ textTransform: 'capitalize' }}>
                      Other Environment Settings:
                    </label>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Enable Debug Flag
                      </label>

                      <Control.select
                        model=".debug"
                        autoFocus
                        value={this.state.debug}
                        onChange={(e) => (this.setState({debug : e.target.value}))}
                        required
                      >
                        {(this.state.envjson.env.debug === "" || this.state.envjson.env.debug === null) && <option value="">Select</option>}
                        <option value="true">true</option>
                        <option value="false">false</option>
                      </Control.select>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Enable Schema Validation
                      </label>

                      <Control.select
                        model=".schemaValidation"
                        value={this.state.schema_validation}
                        onChange={(e) => (this.setState({schema_validation : e.target.value}))}
                        required
                      >
                        {(this.state.envjson.env.schema_validation === "" || this.state.envjson.env.schema_validation === null || this.state.envjson.env.schema_validation === undefined) && <option value="">Select</option>}
                        <option value="true">true</option>
                        <option value="false">false</option>
                      </Control.select>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Spark Shuffle Partition Number
                      </label>
                      <Control.text model=".partition"
                                    value={this.state.partitionnum}
                                    onChange={(e) => (this.setState({partitionnum : e.target.value}))}
                                    type="number"
                                    validators={{
                                      endwith: val => {
                                        if (val === undefined) {
                                          return this.state.partitionnum >= 1 && this.state.partitionnum <= 1000
                                        } else {
                                          return val >= 1 && val <= 1000;
                                        }
                                      }
                                    }}
                                    required/>
                      <Errors
                        className="error"
                        style={{color : 'red'}}
                        model=".partition"
                        messages={{
                          endwith: 'number should be 1 to 1000'
                        }}
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Host
                      </label>
                      <Control.text model="company.partition"
                                    value={this.state.batchhost}
                                    onChange={(e) => (this.setState({batchhost : e.target.value}))}
                                    type="string"
                                    required/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        User_name
                      </label>
                      <Control.text model="company.partition"
                                    value={this.state.batchusername}
                                    onChange={(e) => (this.setState({batchusername : e.target.value}))}
                                    type="string"
                                    required/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Password
                      </label>
                      <Control.text model="company.partition"
                                    value={this.state.batchpassword}
                                    onChange={(e) => (this.setState({batchpassword : e.target.value}))}
                                    type="string"
                                    required/>
                    </fieldset>

                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                        onClick={()=>{
                          this.state.jdbclist.length !== 0 ?
                            this.setState({page:3,subtitle: "Update target environment  JDBC data source connectivity"}) :
                            this.setState({page:2,subtitle: "Create a target environment"})
                        }}
                      >
                        <FormattedMessage
                          id="run-assessment.back.button.name"
                          textTransform="capitalize"
                          defaultMessage="Back"
                        />
                      </button>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                      >
                        SAVE & NEXT
                      </button>
                    </div>
                  </div>
                </LocalForm>
              )}

              {this.state.page === 5 &&(
                <LocalForm
                  model = "company"
                  className="form"
                  onSubmit={()=>{this.release()}}
                >
                  <div>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>

                      <Control.text model="company.dataFactory"
                                    value = {this.state.dataFactory}
                                    type="string"
                                    readOnly
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Pipeline Project Name
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.project}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Target Environment
                      </label>

                      <Control.text model="company.project"
                                    value = {this.state.env.envName.toUpperCase()}
                                    type="string"
                                    readOnly/>
                    </fieldset>

                    <div style={{backgroundColor: 'grey'}}>
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>Code Build/Release Version</label>
                        <Control.text model=".tag"
                                      value = {this.state.tag}
                                      type="string"
                                      readOnly/>
                      </fieldset>
                    </div>

                    <label style={{ textTransform: 'capitalize' }}>
                      <Checkbox
                        onChange={e => this.checkRelease(e)}
                        checked={this.state.releasebtn}
                      />
                      Release source code to customer and notify customer’s user
                    </label>

                    <br/>
                    <br/>
                    <br/>
                    {this.state.loading && (
                      <div>
                        Build source code in progress...
                      </div>
                    )}

                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                        onClick={()=>{this.setState({page:4,subtitle: "Update target environment  JDBC data source connectivity"})}}
                      >
                        <FormattedMessage
                          id="run-assessment.back.button.name"
                          textTransform="capitalize"
                          defaultMessage="Back"
                        />
                      </button>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                      >
                        SUBMIT
                      </button>
                    </div>
                  </div>
                </LocalForm>
              )}

              {this.state.page === 6 &&(
                <div>
                  <label
                    style={{
                      width: '90%',
                      fontSize: '16px',
                      textTransform: 'none',
                      lineHeight: '150%'
                    }}
                  >
                    The source code has been successfully built.
                  </label>
                  <br />
                  &nbsp;
                  <br />
                  &nbsp;

                  <Link to={{
                    pathname: '/en-CA/projectmanagement/' + this.props.location.state[0].dataFactory + '/' + this.props.location.state[0].dataFactoryId,
                    state:[{
                      dataFactory : this.state.dataFactory,
                      dataFactoryId : this.state.dataFactoryId,
                      companyname : this.state.companyname,
                      customer : this.state.customer,
                      project: this.state.project
                    }]
                  }}>
                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button
                        className="button"
                        styel={{ padding: 20 }}
                        type="button"
                      >
                        <FormattedMessage id="nav.ok" defaultMessage="OK" />
                      </button>
                    </div>
                  </Link>
                </div>
              )}

            </div>
          )}

        </div>


        <Footer />
      </div>
    );
  }
}

BuildCode.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(BuildCode);



// WEBPACK FOOTER //
// ./src/components/views/BuildCode/index.js